import React from 'react';
import { HeartHandshake, X } from 'lucide-react';

interface PortalGuruModalShiftSelesaiProps {
    onClose: () => void;
    namaUser: string;
}

export const PortalGuruModalShiftSelesai: React.FC<PortalGuruModalShiftSelesaiProps> = ({ onClose, namaUser }) => {
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
            <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
            <div className="relative w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl ring-1 ring-white/10 transform transition-all animate-in slide-in-from-bottom-10 fade-in duration-300 text-center">
                <div className="absolute top-4 right-4">
                    <button onClick={onClose} className="p-1 rounded-full text-gray-500 hover:bg-gray-100 transition-colors">
                        <X size={20} />
                    </button>
                </div>

                <div className="mx-auto w-24 h-24 rounded-full bg-emerald-100 flex items-center justify-center mb-6 ring-8 ring-emerald-50">
                    <HeartHandshake size={48} className="text-emerald-600" />
                </div>

                <h3 className="text-xl font-bold text-[#111813] tracking-tight mb-2">Ahlan, {namaUser}</h3>
                <p className="text-sm text-[#63886f] mb-6 leading-relaxed">
                    Kamu sudah bekerja dengan baik di shift yang kamu pilih. Kita bertemu di shift selanjutnya.
                </p>

                <div className="bg-emerald-50 border border-emerald-100 rounded-2xl p-4 mb-8 text-left relative overflow-hidden">
                    <span className="material-symbols-outlined absolute top-2 right-2 text-emerald-200 text-4xl -rotate-12 select-none opacity-20 font-serif">"</span>
                    <p className="text-xs leading-relaxed font-medium text-emerald-800 italic relative z-10">
                        "Semoga pekerjaanmu membawa berkah. Jazakumullahu Khairan."
                    </p>
                </div>

                <button
                    onClick={onClose}
                    className="w-full py-3.5 bg-[#40513B] hover:bg-[#344230] text-white font-bold rounded-xl shadow-lg shadow-[#40513B]/25 transition-all active:scale-[0.98]"
                >
                    Aamiin, Tutup
                </button>
            </div>
        </div>
    );
};
